import Auth from "./screens/Auth";
import Common from "./screens/Common";
import Locale from "../components/Locale";
import Users from "./screens/Users";
import Restaurants from "./screens/Restaurants";
import ThreeDSecure from "./screens/3dSecure";

import Help from "../components/Locale/Help";

const routes = [
  {
    path: "/",
    name: "home",
    exact: true,
    component: Common.Home
  },
  {
    path: "/verifyEmail/:key",
    name: "email-verification",
    exact: true,
    component: Common.Home
  },
  {
    path: "/walletVerifyEmail/:key",
    name: "wallet-email-verification",
    exact: true,
    component: Common.Home
  },
  {
    path: "/unsubscribe",
    name: "unsubscribe",
    exact: true,
    component: Common.Home
  },
  {
    path: "/unsubscribe/:token",
    name: "unsubscribe-old",
    exact: true,
    component: Common.Home
  },
  {
    path: "/profile",
    name: "info",
    component: Users.ProfileInfo,
    exact: true,
    private: true
  },
  {
    path: "/rewards",
    name: "rewards",
    component: Users.Rewards,
    exact: true
  },
  {
    path: "/why-local-e",
    name: "why-local-e",
    component: Locale.WhyLocalE,
    exact: true
  },
  {
    path: "/track-order/:orderUid",
    name: "track-order",
    component: Restaurants.OrderTrack,
    exact: true,
    private: true
  },
  {
    path: "/search",
    name: "search",
    component: Restaurants.Search
  },
  {
    path: "/restaurants/:city/:adminWard/",
    exact: true,
    name: "list",
    component: Restaurants.List
  },
  {
    path: "/restaurants/:city/list/",
    exact: true,
    name: "list",
    component: Restaurants.List
  },
  {
    path: "/restaurant/:city/:adminWard/:restaurantName/",
    name: "detail",
    exact: true,
    component: Restaurants.Detail
  },
  {
    path: "/checkout",
    name: "checkout",
    component: Restaurants.CheckOut
  },
  {
    path: "/login",
    name: "login",
    component: Auth.Login
  },
  {
    path: "/register",
    name: "register",
    component: Auth.Signup
  },
  {
    path: "/join-us",
    name: "join-us",
    component: Auth.JoinUs
  },
  {
    path: "/callback/payment/checkout",
    name: "3d-checkout",
    component: ThreeDSecure.ThreeDCheckout
  },
  {
    path: "/callback/payment/tip",
    name: "3d-tip",
    component: ThreeDSecure.ThreeDTip
  },
  {
    path: "/callback/payment/shop",
    name: "3d-payment",
    component: ThreeDSecure.ThreeDPayment
  },
  {
    path: "/terms",
    name: "terms",
    component: Common.Terms
  },
  {
    path: "/privacy",
    name: "privacy",
    component: Common.Privacy
  },
  {
    path: "/cookies",
    name: "cookies",
    component: Common.Cookies
  },
  {
    path: "/invite/:userRefCode",
    name: "invite-user",
    component: Auth.InviteUser
  },
  {
    path: "/help",
    name: "help",
    component: Help
  },
  {
    path: "/about-us",
    name: "about",
    component: Locale.About
  },
  {
    path: "/share-the-love",
    name: "share-the-love",
    private: true,
    component: Locale.ShareTheLove
  },

  {
    path: "*",
    name: "notfound",
    component: Common.NotFound
  }
];

export { routes };
